export default {
  items: [
    {
      link: 'https://github.com/WiSchLabs',
      text_color: '#FFFFFF',
      description: 'Our profile page on GitHub',
      background_logo: 'GitHub_white.svg',
      background_color: '#000000',
    },
    {
      link: 'https://github.com/WiSchLabs/Kicktipper',
      description: 'Calculating tips for football predictions games on Kicktipp',
      background_logo: 'Kicktipper.png',
      background_color: '#999999',
    },
    {
      link: 'https://github.com/WiSchLabs/Locality-finder',
      text_color: '#FFFFFF',
      description: 'Django based webpage for finding local events',
      background_logo: 'LocalityFinder_white.png',
      background_color: '#009688',
    },
    {
      link: 'https://github.com/WiSchLabs/Sudoklin',
      text_color: '#000000',
      description: 'Kotlin based Sudoku solver',
      background_logo: 'Sudoklin_.png',
      background_logo_size: 'contain',
      background_color: '#FFFFFF',
    },
    {
      link: 'https://github.com/WiSchLabs/ofm_helper',
      text_color: '#FFFFFF',
      description: 'Django based helper tool for onlinefussballmanager.de',
      background_logo: 'OFM_Helper_sw.png',
      background_color: '#239123',
    },
  ],
  settings: {
    default_link_target: '_blank',
  },
};
